import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ADD_EQUI_LABEL, SPOT_TYPE_LABEL } from '@shared/constant/shared.constant';

@Component({
  selector: 'app-equipment-info-list',
  templateUrl: './equipment-info-list.component.html',
  styleUrls: ['./equipment-info-list.component.scss']
})
export class EquipmentInfoListComponent {
  @Input() addButton: boolean;
  @Input() allDriverVehicle;
  @Output() rowEdit = new EventEmitter<any>();
  @Output() rowDelete = new EventEmitter<{ event: any; product: any }>();
  @Output() addEquipment = new EventEmitter<any>();
  addEquiMsg: string = ADD_EQUI_LABEL;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  activeItem: any;
  items: any;

  showData(event, product) {
    const actionMap = {
      Edit: () => {
        this.rowEdit.emit(product);
      },
      Delete: () => {
        this.rowDelete.emit({ event, product });
      }
    }
    this.items = [
      {
        items: [
          {
            label: '',
            icon: '',

},
          {
            label: 'Edit',
            icon: 'common-icon custom-editicon',
            escape: false,
            command: actionMap.Edit
          },
          {
            label: 'Delete',
            icon: 'common-icon custom-delete',
            escape: false,
            command: actionMap.Delete
          },
        ]
      },
    ];
  };

  addEquipmentInfo() {
    this.addEquipment.emit({ data: null });
  }

}
